import { createSlice } from "@reduxjs/toolkit";
import { getCustomerAPI } from "../../api/dashboard";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getCustomerSlice = createSlice({
  name: "getCustomer",
  initialState: data,
  reducers: {
    getCustomerSlice(state) {
      state.isLoading = true;
    },
    getCustomerSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCustomerSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCustomerSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCustomerHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(getCustomerAction.getCustomerSlice());
    const response: any = await getCustomerAPI(data);

    dispatch(getCustomerAction.getCustomerSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCustomerAction.getCustomerSliceFailure(e?.response?.data));
  }
};
export default getCustomerSlice.reducer;
export const getCustomerAction = getCustomerSlice.actions;
